export const saleForms = {
  forms: ['продаж', 'продажі', 'продажів'],
};

export const contractForms = {
  forms: ['договір', 'договори', 'договорів'],
};

export const insuranceForms = {
  forms: ['поліс', 'поліси', 'полісів'],
};

export const insuranceProlongationForms = {
  forms: ['пролонгація полісу', 'пролонгації полісів', 'пролонгацій полісів'],
};

export const workingDays = {
  forms: ['робочого дня', 'робочих днів', 'робочих днів'],
};

export const secondsForms = {
  forms: ['секунду', 'секунди', 'секунд'],
};

export const ageForms = {
  forms: ['рік', 'роки', 'років'],
};
